import { CheckCircle, AlertCircle, ShoppingBag, UserPlus } from 'lucide-react'

const RecentActivity = () => {
  const activities = [
    {
      id: 1,
      type: 'success' as const,
      icon: CheckCircle,
      title: 'Nouveau commerçant ajouté',
      description: 'Boulangerie du Marché a été créé',
      time: 'Il y a 5 minutes',
    },
    {
      id: 2,
      type: 'warning' as const,
      icon: AlertCircle,
      title: 'Réservation annulée',
      description: 'Réservation #4587 a été annulée',
      time: 'Il y a 15 minutes',
    },
    {
      id: 3,
      type: 'info' as const,
      icon: ShoppingBag,
      title: 'Nouvelle commande',
      description: 'Commande #7890 de 245€',
      time: 'Il y a 30 minutes',
    },
    {
      id: 4,
      type: 'info' as const,
      icon: UserPlus,
      title: 'Nouvel utilisateur',
      description: 'Marie Dupont s\'est inscrite',
      time: 'Il y a 1 heure',
    },
    {
      id: 5,
      type: 'success' as const,
      icon: CheckCircle,
      title: 'Paiement validé',
      description: 'Paiement #1234 de 89€',
      time: 'Il y a 2 heures',
    },
  ]

  const typeColors = {
    success: 'text-success-500 bg-success-50',
    warning: 'text-warning-500 bg-warning-50',
    info: 'text-primary-500 bg-primary-50',
  }

  return (
    <div className="divide-y divide-gray-200">
      {activities.map((activity) => {
        const Icon = activity.icon
        return (
          <div key={activity.id} className="flex items-start px-4 py-3 hover:bg-gray-50">
            <div className={`p-2 rounded-lg ${typeColors[activity.type]}`}>
              <Icon className="h-4 w-4" />
            </div>
            <div className="ml-3 flex-1">
              <p className="text-sm font-medium text-gray-900">{activity.title}</p>
              <p className="text-sm text-gray-600">{activity.description}</p>
              <p className="text-xs text-gray-500 mt-1">{activity.time}</p>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default RecentActivity
